import React from 'react';
import { Badge } from 'shards-react';
import type { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

const IsActiveRenderer = (props: ICellRendererParams) => {
  const { t } = useTranslation();

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(inventoryJobRowData);
  // }, [inventoryJobRowData]);

  return (
    <>
      <div className="is-active-badge">
        {props.getValue() === true ? (
          <Badge pill theme="success">
            {t('isValid.valid')}
          </Badge>
        ) : (
          <Badge className="text-muted" pill theme="light">
            {t('isValid.invalid')}
          </Badge>
        )}
      </div>
    </>
  );
};

export default IsActiveRenderer;
